import { Locale } from "date-fns";
import { nb, nn } from "date-fns/locale";
import i18n from "i18next";

export default function currentLocale(): Locale {
  return i18n.language === "nn" ? nn : nb;
}
